import React from 'react';
import { Button } from 'react-bootstrap5';

export default function Disable() {
  return (

    <Button
      variant="light"
      className="btn-reverse ms-3 mb-3 mb-lg-0 step-action-btn disabled"
      disabled
    >
      Feedback
    </Button>
  );
}
